<template>
  <div id="listWidget" class="mb-4">
    <div class="instruction-card card-item mb-3">
      <div class="instruction-header">
        <i class="fa-solid fa-link me-2 text-primary"></i>
        <span class="instruction-title">{{ props.step }}. {{ props.title || '조명제어기 연결' }}</span>
      </div>
      <div class="instruction-body">
        <div class="instruction-step">
          <div class="instruction-step-number">1</div>
          <div class="instruction-step-content">
            <span>스마트폰 <strong class="text-primary">단말기의 Wifi</strong>를 켜주세요.</span>
          </div>
        </div>
        <div class="instruction-step">
          <div class="instruction-step-number">2</div>
          <div class="instruction-step-content">
            <span>조명제어기의 <strong class="text-primary">리셋 버튼</strong>을
              <strong class="text-primary">10초 이상</strong> 눌러 세팅 모드로
              진입하세요. 세팅 모드가 되면 전원 LED가 깜빡거립니다.</span>
          </div>
        </div>
        <div class="instruction-step">
          <div class="instruction-step-number">3</div>
          <div class="instruction-step-content">
            <span>아래의 <strong class="text-primary">연결 버튼</strong>을 눌러서 조명제어기 AP에
              연결해주세요.</span>
          </div>
        </div>
        <div class="instruction-step" v-for="(message, index) in (props.warningMessages || [])" :key="index">
          <div class="instruction-step-number">{{ index + 4 }}</div>
          <div class="instruction-step-content">
            <span class="text-danger">{{ message }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps(['step', 'title', 'warningMessages']);
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.instruction-step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.instruction-step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}

.instruction-step-content .text-primary {
  color: #0d6efd;
  font-weight: 600;
}
</style>
